// import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { useState } from 'react';
// import { useForm } from 'react-hook-form';
// import { FaCheck } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { z } from 'zod';

// import { PasswordChangeModal } from '@/components/auth/PasswordChangeModal';
// import { ResetPasswordModal } from '@/components/auth/ResetPasswordModal';
import { GuestLayout } from '@/components/layouts/GuestLayout';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
// import {
//   Form,
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from '@/components/ui/form';
// import { Input } from '@/components/ui/input';
// import { Separator } from '@/components/ui/separator';
import { useOneRosterAuth } from '@/hooks/useOneRosterAuth';
import { OneRosterUser } from '@/types/user.oneroster';

export const Route = createFileRoute('/login')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      error_description: fallback(z.string(), '').default(''),
      error: fallback(z.string(), '').default(''),
      schoolId: z.string().optional(),
    })
  ),
  ssr: false,
});

const getAuthorizationUrl = (schoolId?: string) => {
  if (typeof window === 'undefined') {
    return null;
  }

  // Construct the Cognito authorization URL
  const cognitoDomain = import.meta.env.VITE_ALPHA_1EDTECH_API_IDP.replace(
    'https://',
    ''
  ).replace('/oauth2', ''); // Extract the domain
  const clientId = import.meta.env.VITE_ALPHA_COGNITO_SIGNIN_CLIENT_ID;
  const redirectUri = `${window.location.origin}/api/auth/callback`;
  const scope = 'email openid profile'; // Adjust scopes as needed
  const responseType = 'code';
  const identityProvider = 'Google';

  const params = new URLSearchParams();
  params.set('identity_provider', identityProvider);
  params.set('response_type', responseType);
  params.set('client_id', clientId);
  params.set('redirect_uri', redirectUri);
  params.set('scope', scope);
  params.set('prompt', 'select_account');

  // Use state parameter to preserve schoolId through OAuth flow
  if (schoolId) {
    const state = JSON.stringify({ schoolId });
    params.set('state', state);
  }

  const authorizationUrl = `https://${cognitoDomain}/oauth2/authorize?${params.toString()}`;

  return authorizationUrl;
};

// const loginSchema = z.object({
//   email: z.string().email('Please enter a valid email'),
//   password: z.string().min(1, 'Please enter your password'),
// });

// type LoginForm = z.infer<typeof loginSchema>;

function RouteComponent() {
  const params = Route.useSearch();
  const auth = useOneRosterAuth();
  const [isLoading, setIsLoading] = useState(false);
  // const [showEmailForm, setShowEmailForm] = useState(false);
  // const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(false);
  // const [emailForPasswordChange, setEmailForPasswordChange] = useState('');
  // const [loginSuccess, setLoginSuccess] = useState(false);
  // const [loginError, setLoginError] = useState('');
  // const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const error = params.error;
  const errorDescription = params.error_description;
  const schoolId = params.schoolId;

  const getErrorMessage = (customError?: string) => {
    if (customError) return customError;
    if (errorDescription) return errorDescription;
    if (error === 'account_disabled') {
      return 'Your account is disabled. Please contact your guide for assistance.';
    }
    return error || 'An unknown error occurred.';
  };

  const hasError = () => {
    return !!(error || errorDescription);
  };

  // const form = useForm<LoginForm>({
  //   resolver: zodResolver(loginSchema),
  //   defaultValues: {
  //     email: '',
  //     password: '',
  //   },
  // });

  const handleGoogleSignIn = () => {
    const authorizationUrl = getAuthorizationUrl(schoolId);
    if (authorizationUrl) {
      window.location.href = authorizationUrl;
    } else {
      console.error('Failed to get authorization URL');
    }
  };

  // const handleEmailLogin = async (data: LoginForm) => {
  //   setIsLoading(true);
  //   setLoginError('');
  //   try {
  //     const response = await fetch('/api/auth/login', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(data),
  //     });
  //
  //     const result = await response.json();
  //
  //     if (result.success) {
  //       setLoginSuccess(true);
  //       setTimeout(() => {
  //         window.location.href = '/';
  //       }, 1000);
  //     } else {
  //       if (result.needsPasswordChange) {
  //         setEmailForPasswordChange(data.email);
  //         setShowPasswordChangeModal(true);
  //       } else {
  //         setLoginError(result.message || 'Login failed');
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Login error:', error);
  //     setLoginError('An unexpected error occurred');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <GuestLayout
      isAuthenticated={auth.isAuthenticated}
      isLoading={auth.isLoading}
      user={auth.user as OneRosterUser | null}
      error={auth.error}
      redirectTo="/app"
      schoolId={schoolId}
    >
      <div className="flex font-lexend min-h-screen flex-col items-center justify-center bg-[radial-gradient(1200px_600px_at_20%_0%,rgba(108,92,231,.16),transparent),radial-gradient(1000px_600px_at_100%_40%,rgba(71,216,178,.14),transparent)] p-5 gap-12">
        <img src="/logo.png" alt="TimeBack" className="w-80 mt-[-15vh]" />
        <div className="text-5xl font-bold text-[#0F33BB] w-2xl text-center px-5">
          Crush academics in only 2 hours per day
        </div>

        <Card className="border-muted/40 shadow-2xl rounded-4xl w-2xl flex-col">
          <CardHeader className="space-y-1">
            <CardTitle className="text-3xl text-center">Welcome back</CardTitle>
            <CardDescription className="text-xl font-light text-center mt-1">
              Kids - get your time back
            </CardDescription>
          </CardHeader>

          <CardContent className="pb-3 flex flex-col">
            {hasError() && (
              <Alert variant="destructive" className="mb-6 w-lg mx-auto">
                <AlertDescription className="text-center">
                  {getErrorMessage()}
                </AlertDescription>
              </Alert>
            )}

            <div className="space-y-4">
              <Button
                onClick={handleGoogleSignIn}
                size="lg"
                variant="outline"
                className="w-full py-6 relative bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/50"
                disabled={isLoading}
              >
                <FcGoogle className="mr-2 size-5" />
                <span>Sign in with Google</span>
              </Button>

              {/*<div className="flex items-center">*/}
              {/*  <Separator className="flex-1" />*/}
              {/*  <span className="px-3 text-sm text-muted-foreground">OR</span>*/}
              {/*  <Separator className="flex-1" />*/}
              {/*</div>*/}

              {/*<Button*/}
              {/*  onClick={() => setShowEmailForm(true)}*/}
              {/*  size="lg"*/}
              {/*  variant="default"*/}
              {/*  className="w-full py-6"*/}
              {/*  disabled={isLoading}*/}
              {/*>*/}
              {/*  Sign in with Email*/}
              {/*</Button>*/}
            </div>

            {/*<div className="space-y-4">*/}
            {/*  <div className="flex items-center justify-between mb-4">*/}
            {/*    <h3 className="text-lg font-medium">Sign in with Email</h3>*/}
            {/*    <Button*/}
            {/*      type="button"*/}
            {/*      variant="ghost"*/}
            {/*      size="sm"*/}
            {/*      onClick={() => setShowEmailForm(false)}*/}
            {/*      disabled={isLoading}*/}
            {/*    >*/}
            {/*      ← Back*/}
            {/*    </Button>*/}
            {/*  </div>*/}

            {/*  <Form {...form}>*/}
            {/*    <form*/}
            {/*      onSubmit={form.handleSubmit(handleEmailLogin)}*/}
            {/*      className="space-y-4"*/}
            {/*    >*/}
            {/*      <FormField*/}
            {/*        control={form.control}*/}
            {/*        name="email"*/}
            {/*        render={({ field }) => (*/}
            {/*          <FormItem>*/}
            {/*            <FormLabel>Email</FormLabel>*/}
            {/*            <FormControl>*/}
            {/*              <Input*/}
            {/*                type="email"*/}
            {/*                placeholder="Enter your email"*/}
            {/*                {...field}*/}
            {/*                disabled={isLoading}*/}
            {/*              />*/}
            {/*            </FormControl>*/}
            {/*            <FormMessage />*/}
            {/*          </FormItem>*/}
            {/*        )}*/}
            {/*      />*/}
            {/*      <FormField*/}
            {/*        control={form.control}*/}
            {/*        name="password"*/}
            {/*        render={({ field }) => (*/}
            {/*          <FormItem>*/}
            {/*            <FormLabel>Password</FormLabel>*/}
            {/*            <FormControl>*/}
            {/*              <Input*/}
            {/*                type="password"*/}
            {/*                placeholder="Enter your password"*/}
            {/*                {...field}*/}
            {/*                disabled={isLoading}*/}
            {/*              />*/}
            {/*            </FormControl>*/}
            {/*            <FormMessage />*/}
            {/*          </FormItem>*/}
            {/*        )}*/}
            {/*      />*/}

            {/*      <div className="flex justify-end">*/}
            {/*        <button*/}
            {/*          type="button"*/}
            {/*          onClick={() => setShowResetPasswordModal(true)}*/}
            {/*          className="text-sm text-blue-600 hover:text-blue-800 hover:underline"*/}
            {/*          disabled={isLoading || loginSuccess}*/}
            {/*        >*/}
            {/*          Forgot Password?*/}
            {/*        </button>*/}
            {/*      </div>*/}

            {/*      <Button*/}
            {/*        type="submit"*/}
            {/*        size="lg"*/}
            {/*        className={`w-full py-6 transition-all duration-300 ${*/}
            {/*          loginSuccess ? 'bg-green-900 text-white' : ''*/}
            {/*        }`}*/}
            {/*        disabled={isLoading || loginSuccess}*/}
            {/*      >*/}
            {/*        {loginSuccess ? (*/}
            {/*          <div className="flex items-center gap-2">*/}
            {/*            <FaCheck />*/}
            {/*            Success!*/}
            {/*          </div>*/}
            {/*        ) : isLoading ? (*/}
            {/*          'Signing in...'*/}
            {/*        ) : (*/}
            {/*          'Sign In'*/}
            {/*        )}*/}
            {/*      </Button>*/}
            {/*    </form>*/}
            {/*  </Form>*/}
            {/*</div>*/}
          </CardContent>

          {/*<CardFooter className="justify-center flex-col gap-2 px-10">*/}
          {/*  <p className="text-sm text-muted-foreground font-light text-center">*/}
          {/*    By continuing, you understand that this app is under active*/}
          {/*    development and some features may not work as expected. Contact*/}
          {/*    your guide or teacher if you have any questions.*/}
          {/*  </p>*/}
          {/*</CardFooter>*/}
        </Card>

        {/*<PasswordChangeModal*/}
        {/*  open={showPasswordChangeModal}*/}
        {/*  onOpenChange={setShowPasswordChangeModal}*/}
        {/*  email={emailForPasswordChange}*/}
        {/*/>*/}

        {/*<ResetPasswordModal*/}
        {/*  open={showResetPasswordModal}*/}
        {/*  onOpenChange={setShowResetPasswordModal}*/}
        {/*/>*/}
      </div>
    </GuestLayout>
  );
}
